import axios from 'axios';
// import moment from 'moment';


import { SaveIntVal } from '../SaveIntVal/SaveIntVal';
import { HobbyActionInit } from './NewJuneModels/HobbyActionInit';
import { HobbyModel } from './NewJuneModels/HobbyModel';
import { HobbyOneLiner } from './NewJuneModels/HobbyOneLiner';
import { HobbyProbing } from './NewJuneModels/HobbyProbing';
// import { InterestedInModel } from './NewJuneModels/InterestedInModel';
import { JobRoleModel } from './NewJuneModels/JobRoleModel';
import { LikedPostModel } from './NewJuneModels/LikedPostModel';
import { LocationModel } from './NewJuneModels/LocationModel';
import { PersonalValueModel } from './NewJuneModels/PersonalValueModel';
import { QuotesModel } from './NewJuneModels/QuotesModel';
import { SharedPostModel } from './NewJuneModels/SharedPostModel';
import { WorkActionInit } from './NewJuneModels/WorkActionInit';
// import { WorkEventModel } from './NewJuneModels/WorkEventModel';
import { WorkIntModel } from './NewJuneModels/WorkIntModel';
import { WorkOneLiner } from './NewJuneModels/WorkOneLiner';
import { WorkProbing } from './NewJuneModels/WorkProbing';
import { WrittenPostModel } from './NewJuneModels/WrittenPostModel';


var arr = [];

//filter interest if no interest label arrived yet to see what model we will use with the classifier (either interest or work goal...
//...company info, personal articles, should come in with the interest already labeled and sent to model)
export const onBoardingFunc = (
    profile, 
    fbProfile, 
    vProp, 
    intVal, 
    auth, 
    setContentGen, 
    setGenerating, 
    tokens, 
    docId, 
    url, 
    sendArr, 
    foundInts,
    interestValues,
    setBtnClicked,
    setShowTooltip,
    onboarded,
    teamToken,
    tokensTeam,
    callToAction
) =>{
    setGenerating(true)
    setBtnClicked(false)

    HobbyModel(
        profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam
    )

}

export const getIntro = (
    profile, 
    fbProfile, 
    vProp, 
    intVal, 
    auth, 
    setContentGen, 
    setGenerating, 
    tokens, 
    docId, 
    url, 
    sendArr, 
    foundInts,
    interestValues,
    setBtnClicked,
    setShowTooltip,
    callToAction,
    setEditing,
    teamToken,
    tokensTeam,
    oneLinerModel,
    actionInitModel,
    probingModel,
    onboarded,
    ) =>{

    setGenerating(true)
    searchData(intVal, interestValues);
    setBtnClicked(false)
    setEditing(false)
    // console.log(oneLinerModel)
    // setShowTooltip(true)
    
    if(intVal.activity_status?.includes('Shared')){
        SharedPostModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
    } else if(intVal.activity_status?.includes('Liked')){
        LikedPostModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
    } else if(intVal.activity_status?.includes('Posted')){
        WrittenPostModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction)
    } else if(intVal.includes('"')){
        // console.log('hobby withoutAxios')
        // console.log("here")
        QuotesModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
    } else if(arr.length > 0){
        if(oneLinerModel === true){
            if(arr[0].classified === 'Hobby'){
                // console.log('hobby withoutAxios')
                HobbyOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(arr[0].classified === 'Work'){
                // console.log('work withoutAxios')
                WorkOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } else{
                WorkOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            }
        }
        else if(actionInitModel === true){
            if(arr[0].classified === 'Hobby'){
                // console.log('hobby withoutAxios')
                HobbyActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(arr[0].classified === 'Work'){
                // console.log('work withoutAxios')
                WorkActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } else{
                WorkActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            }
        }
        else if(probingModel === true){
            if(arr[0].classified === 'Hobby'){
                // console.log('hobby withoutAxios')
                HobbyProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(arr[0].classified === 'Work'){
                // console.log('work withoutAxios')
                WorkProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } else{
                WorkProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            }
        }
        else if(arr[0].classified === 'Hobby'){
            // console.log('hobby withoutAxios')
            HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Work'){
            // console.log('work withoutAxios')
            WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Role'){
            // console.log('work withoutAxios')
            JobRoleModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Location'){
            // console.log('work withoutAxios')
            LocationModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Value'){
            // console.log('work withoutAxios')
            PersonalValueModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Interested In' || arr[0].classified === 'Interested in'){
            // console.log('work withoutAxios')
            HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            // InterestedInModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else if(arr[0].classified === 'Work Event' || arr[0].classified === 'Work event'){
            // console.log('work withoutAxios')
            WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            // HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            // WorkEventModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        } 
        else{
            HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            // console.log('othered withoutAxios')
            // WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
        }
    } else {
        // console.log('axios');
        const message= { Input: intVal }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/newClassifierModel', message)
        .then((response) => {
            let classified = response.data
            // console.log(classified)
            SaveIntVal(intVal, classified);
            // console.log(classified)
            if(oneLinerModel === true){
                if(classified === 'Hobby'){
                    // console.log('hobby withoutAxios')
                    HobbyOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } 
                else if(classified === 'Work'){
                    // console.log('work withoutAxios')
                    WorkOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } else{
                    WorkOneLiner(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                }
            }
            else if(actionInitModel === true){
                if(classified === 'Hobby'){
                    // console.log('hobby withoutAxios')
                    HobbyActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } 
                else if(classified === 'Work'){
                    // console.log('work withoutAxios')
                    WorkActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } else{
                    WorkActionInit(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                }
            }
            else if(probingModel === true){
                if(classified === 'Hobby'){
                    // console.log('hobby withoutAxios')
                    HobbyProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } 
                else if(classified === 'Work'){
                    // console.log('work withoutAxios')
                    WorkProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                } else{
                    WorkProbing(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                }
            }
            else if(classified === 'Hobby'){
                HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Work'){
                WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Role'){
                JobRoleModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Location'){
                LocationModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Value'){
                PersonalValueModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Interested In' || classified === 'Interested in'){
                HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                // InterestedInModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else if(classified === 'Work Event' || classified === 'Work event' ){
                WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                // HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                // WorkEventModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            } 
            else{
                HobbyModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
                // WorkIntModel(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, setShowTooltip, callToAction, onboarded, teamToken, tokensTeam)
            }
        })
    }
}



const searchData = (e, projects) => {
    arr = projects.filter(dataContainsTerm(e))
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.intVal.toString().toLowerCase() === word &&
            startsWith(data.intVal.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}

